import styled from 'styled-components';

export const UserPanelTerminalViewWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  gap: 12px;
  overflow: hidden;

  & svg {
    font-size: 60px;
  }
`;
